import React from "react";
import { ReactComponent as NoFoundImg } from "../../../assets/illustrations/404-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const NotFoundPage: React.FC = () => {
  return (
    <ServicesLayout image={<NoFoundImg />} title="404">
      <div className="text-base theme-text-secondary">
        The page you are looking for doesn’t exist.
        <br />
        If you think something is broken contact customer support.
      </div>
    </ServicesLayout>
  );
};
